import Drivers from '../modules-drivers'

class modulesDriversLoader {
    static async load() {
        const activeModule = window.localStorage.getItem('module')

        const moduleDriver = Drivers.find(
            (driver) => driver.name === activeModule
        )

        if (!moduleDriver || !moduleDriver.path) {
            window.alert(
                `${activeModule} module has no driver for risk assessment package!!!`
            )
            return {}
        }

        const { Actions } = await moduleDriver.path()

        return {
            getApiRoutes: () => {
                return Actions.getApiRoutes()
            }
        }
    }
}

export default modulesDriversLoader
